// extracted by mini-css-extract-plugin
export default {"content":"Welcome_content__WtLSP","welcome-page":"Welcome_welcome-page__mNn3f","text-center":"Welcome_text-center__CGdeI"};